const badgesList = [
  { label: "Insider tip", value: "insider" },
  { label: "New", value: "new" },
  { label: "Special offer", value: "special" },
  { label: "Not to miss", value: "experienceX" },
];

export default badgesList;
